import script from "./QuizPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizPlayer.vue?vue&type=script&setup=true&lang=js"

import "./QuizPlayer.vue?vue&type=style&index=0&id=885f9ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-885f9ee0"]])

export default __exports__